
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artists/[...slug]",
      function () {
        return require("private-next-pages/artists/[...slug].tsx");
      }
    ]);
  